import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
});

// Routes that are allowed to fail with 401 silently (auth probing & login flows).
// For ANY other 401 (account disabled, expired session, etc.) we force a hard reload to /login
// so the AuthContext is re-initialised cleanly and the disabled user cannot keep using the app.
const SILENT_401_PATHS = ["/auth/me", "/auth/login", "/auth/register", "/auth/refresh", "/auth/google/exchange"];

api.interceptors.response.use(
    (resp) => resp,
    (error) => {
        const status = error?.response?.status;
        const url = error?.config?.url || "";
        if (status === 401 && !SILENT_401_PATHS.some((p) => url.includes(p))) {
            // Avoid redirect loops if we're already on /login
            if (!window.location.pathname.startsWith("/login")) {
                // Best-effort logout to clear cookies, then hard redirect.
                try {
                    api.post("/auth/logout").catch(() => {});
                } catch {}
                window.location.href = "/login?disabled=1";
            }
        }
        return Promise.reject(error);
    },
);

export default api;
export const API_BASE = `${BACKEND_URL}/api`;

export function formatApiError(detail) {
    if (detail == null) return "Une erreur est survenue. Réessaye.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) =>
                e && typeof e.msg === "string" ? e.msg : JSON.stringify(e),
            )
            .filter(Boolean)
            .join(" ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
